export default {"src":"/_next/static/media/logo web.0699292d.svg","height":1024,"width":3072,"blurWidth":0,"blurHeight":0};